import { render, staticRenderFns } from "./driverDetail.vue?vue&type=template&id=ad97c1ca&scoped=true&"
import script from "./driverDetail.vue?vue&type=script&lang=js&"
export * from "./driverDetail.vue?vue&type=script&lang=js&"
import style0 from "./driverDetail.vue?vue&type=style&index=0&id=ad97c1ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad97c1ca",
  null
  
)

export default component.exports